module.exports = __webpack_public_path__ + "img/shot_tx20032001.9c2bdbce.png";